export default __webpack_public_path__ + "static/ENT-symbol-color-76ab428a8f57af409ecbb5465f006b0a.png";